import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Header, Grid, Form } from 'semantic-ui-react';
import { EssorButton } from 'components';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

class ContactInformation extends Component {
  state = {
    value: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.retrieved)
      && nextProps.retrieved['hydra:member'][0].value !== prevState.value
      && nextProps.retrieved['hydra:member'][0].name === 'CONTACT_INFORMATION'
    ) {
      return {
        value: nextProps.retrieved['hydra:member'][0].value,
      };
    }

    return null;
  }

  render() {
    const { value } = this.state;

    const { loading, selectedOffice, t } = this.props;

    return (
      <div className="section-container">
        <div className="section-general">
          <div className="option-buttons-container clearfix">
            <Header as="h3">{t('companiesContactInformation')}</Header>
            <EssorButton as={Link} to={`/offices/${selectedOffice.id}/settings/contact-information/edit`} type="edit" size="tiny" floated="right">
              {t('buttonEdit')}
            </EssorButton>
          </div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={loading} size="small">
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formStreetName')}</label>
                      <h5 className="informative-field">
                        {value && (value.streetName === '' ? '-' : value.streetName)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formAdditional')}</label>
                      <h5 className="informative-field">
                        {value && (value.additional === '' ? '-' : value.additional)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formZipCode')}</label>
                      <h5 className="informative-field">
                        {value && (value.zipCode === '' ? '-' : value.zipCode)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formCity')}</label>
                      <h5 className="informative-field">
                        {value && (value.city === '' ? '-' : value.city)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formCountry')}</label>
                      <h5 className="informative-field">
                        {value && (value.country === '' ? '-' : value.country)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formPhoneNumber')}</label>
                      <h5 className="informative-field">
                        {value && (value.phone === '' ? '-' : value.phone)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formFax')}</label>
                      <h5 className="informative-field">
                        {value && (value.fax === '' ? '-' : value.fax)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formWebsite')}</label>
                      <h5 className="informative-field">
                        {value && (value.website === '' ? '-' : value.website)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.officeSettings.show.error,
  loading: state.officeSettings.show.loading,
  retrieved: state.officeSettings.show.retrieved,

  selectedOffice: state.userCompanies.select.selectedOffice,
});

const Main = connect(mapStateToProps)(ContactInformation);

export default withTranslation()(withRouter(Main));
